(function () {
  'use strict';

  if (window.__dltCountdownBarsInitialized) {
    return;
  }
  window.__dltCountdownBarsInitialized = true;

  var surfaces = [];

  function parseTarget(surface) {
    var raw = surface.getAttribute('data-dlt-target-epoch');
    var value = parseInt(raw || '', 10);
    return Number.isFinite(value) ? value : NaN;
  }

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function applyUnits(surface, totalSeconds) {
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = Math.floor(totalSeconds % 60);

    var dayNode = surface.querySelector('[data-dlt-days]');
    var hourNode = surface.querySelector('[data-dlt-hours]');
    var minuteNode = surface.querySelector('[data-dlt-minutes]');
    var secondNode = surface.querySelector('[data-dlt-seconds]');

    if (dayNode) dayNode.textContent = pad(days);
    if (hourNode) hourNode.textContent = pad(hours);
    if (minuteNode) minuteNode.textContent = pad(minutes);
    if (secondNode) secondNode.textContent = pad(seconds);
  }

  function expireSurface(surface) {
    var expiredText = surface.getAttribute('data-dlt-expired-text') || 'Oferta encerrada';
    var mode = surface.getAttribute('data-dlt-expire-mode') || 'message';
    var label = surface.querySelector('[data-dlt-countdown-label]');
    var title = surface.querySelector('[data-dlt-countdown-title]');
    var text = surface.querySelector('[data-dlt-countdown-text]');
    var timer = surface.querySelector('[data-dlt-countdown-timer-root]');
    var cta = surface.querySelector('[data-dlt-countdown-cta]');

    if (mode === 'hide') {
      surface.classList.add('dlt-countdown-hidden');
      return;
    }

    if (label) label.textContent = 'Encerrada';
    if (title) title.textContent = expiredText;
    if (text) text.textContent = '';
    if (timer) timer.classList.add('dlt-countdown-hidden');
    if (cta) cta.classList.add('dlt-countdown-hidden');
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);

    surfaces.forEach(function (surface) {
      if (surface.classList.contains('dlt-countdown-hidden')) return;
      var target = parseTarget(surface);
      if (!Number.isFinite(target)) return;

      var totalSeconds = target - now;
      if (totalSeconds <= 0) {
        applyUnits(surface, 0);
        expireSurface(surface);
        return;
      }

      applyUnits(surface, totalSeconds);
    });
  }

  function init() {
    surfaces = Array.prototype.slice.call(document.querySelectorAll('[data-dlt-countdown-surface]'));
    if (!surfaces.length) return;
    tick();
    window.clearInterval(window.__dltCountdownInterval);
    window.__dltCountdownInterval = window.setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
